export const SNOWPACK_PUBLIC_BRANCH = "HEAD";
export const SNOWPACK_PUBLIC_REV = "1d35908";
export const SNOWPACK_PUBLIC_VERSION = "0.42.0";
export const SNOWPACK_PUBLIC_WHALESPLAINER_URL = "https://create.anchor.tools";
export const SNOWPACK_PUBLIC_UNICOVE_URL = "https://unicove.com";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;